import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Services from '../views/Services.vue'
import About from '../views/About.vue'
import Resources from '../views/Resources.vue'

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (args) {
  const {name, hash} = this.history.current;
  if(args.name == name && hash == (args.hash || '')){
    return ;
  }
  return originalPush.call(this, args);
}

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
    meta: {title: 'Business Consulting - Delta Consulting Services'}
  },
  {
    path: '/services',
    name: 'services',
    component: Services,
    meta: {breadcrumb: 'SERVICES', title: 'Services | Delta Consulting provides business & managment consulting'}
  },
  {
    path: '/about',
    name: 'about',
    component: About,
    meta: {breadcrumb: 'ABOUT US', title: 'About Us | Professional Business Growth & Strategy Consultants'}
  },
  // {
  //   path: '/resources',
  //   name: 'resources',
  //   component: Resources,
  //   meta: {breadcrumb: 'RESOURCES', title: 'Resources| Download free business resources to help your business grow'}
  // },
  {
    path: '/business-process',
    name: 'business',
    component:  () => import(/* webpackChunkName: "business-process" */ "@/views/BusinessProcess.vue"),
    meta: {breadcrumb: 'BUSINESS PROCESS', title: 'Business Process | Design and Re-engineering Consultants in Asia'}
  },
  {
    path: '/customer-experience',
    name: 'experience',
    component:  () => import(/* webpackChunkName: "customer-experience" */ "@/views/CustomeExperience.vue"),
    meta: {breadcrumb: 'CUSTOMER EXPERIENCE', title: 'Customer Experience | Leading Customer Experience Consulting'}
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
